import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function BookOverview() {
  const points = ['The cultural climate that preceded what happened', 'The complete account of the case — timeline, institutional response, consequences', 'The international echo: Europe, Latin America, democracies under pressure', 'The legacy of a figure who divided opinions but united a generation around one conviction: that words should not cost a life', 'A serious reflection on free speech, academia, digital media, and the future of public debate in the West'];
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-40">
      <div className="max-w-5xl mx-auto" data-id="element-41">
        {/* Section label */}
        <FadeIn data-id="element-42">
          <div className="flex items-center gap-4 mb-16" data-id="element-43">
            <div className="h-px bg-border-accent flex-grow" data-id="element-44" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-45">
              ◆ The Document ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-46" />
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16" data-id="element-47">
          {/* Left column — What it is + what it's not */}
          <div className="md:col-span-5" data-id="element-48">
            <FadeIn data-id="element-49">
              <h2 className="font-display text-4xl md:text-5xl font-bold text-text-primary leading-tight mb-6" data-id="element-50">
                What This Book Is
              </h2>
              <p className="font-body text-xl text-text-secondary leading-relaxed mb-10" data-id="element-51">
                "The Voice They Couldn't Silence" is a 170-page editorial
                memorial.
              </p>
            </FadeIn>

            {/* Negation block — visually distinct */}
            <FadeIn delay={0.15} data-id="element-52">
              <div className="border border-border-default bg-surface rounded-sm p-6 mb-8" data-id="element-53">
                <p className="font-ui text-xs font-semibold tracking-widest uppercase text-text-muted mb-4" data-id="element-54">
                  What It Is Not
                </p>
                <div className="space-y-3 font-body text-base text-text-secondary" data-id="element-55">
                  <p className="flex items-center gap-3" data-id="element-56">
                    <span className="text-accent-primary/60 text-sm" data-id="element-57">✕</span>
                    Not a manifesto
                  </p>
                  <p className="flex items-center gap-3" data-id="element-58">
                    <span className="text-accent-primary/60 text-sm" data-id="element-59">✕</span>
                    Not propaganda
                  </p>
                  <p className="flex items-center gap-3" data-id="element-60">
                    <span className="text-accent-primary/60 text-sm" data-id="element-61">✕</span>
                    Not a campaign pamphlet
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Right column — What it covers */}
          <div className="md:col-span-7" data-id="element-62">
            <FadeIn delay={0.1} data-id="element-63">
              <p className="font-display text-xl md:text-2xl italic text-text-primary mb-10 leading-relaxed" data-id="element-64">
                It is a carefully constructed document that walks through:
              </p>
            </FadeIn>

            <ul className="space-y-6" data-id="element-65">
              {points.map((point, index) => <FadeIn key={index} delay={0.15 + index * 0.06} data-id="element-66">
                  <li className="flex items-start gap-4 group" data-id="element-67">
                    <div className="mt-2.5 w-2 h-2 bg-accent-primary rotate-45 flex-shrink-0 group-hover:scale-125 transition-transform duration-250" data-id="element-68" />
                    <span className="font-body text-lg text-text-secondary leading-relaxed" data-id="element-69">
                      {point}
                    </span>
                  </li>
                </FadeIn>)}
            </ul>

            {/* Bridge line */}
            <FadeIn delay={0.5} data-id="element-70">
              <p className="font-display text-lg italic text-accent-soft mt-10 leading-relaxed" data-id="element-71">
                Written to be read in full. Designed to be kept forever.
              </p>
            </FadeIn>
          </div>
        </div>

        {/* Bottom CTA */}
        <FadeIn delay={0.6} data-id="element-72">
          <div className="flex flex-col items-center mt-16 text-center" data-id="element-73">
            <Button href="#offer" variant="secondary" className="w-full md:w-auto text-sm md:text-base" data-id="element-74">
              See What's Inside &rarr;
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}